export default "__VITE_ASSET__DYHt$E9a__"